import en from './en';
import ja from './ja';

const translations = {
    en, ja
};

export default translations;
